export type FontLink = {
  family: string;
  url?: string | null;
  source: string;
};

// Discrete weights, not a `400..700` range: the range axis only resolves for variable fonts.
// Google returns a 400 for non-variable families (Poppins, Pacifico, etc.), so the stylesheet
// never loads and the text silently falls back to the inherited brand font.
const googleHref = (family: string): string =>
  `https://fonts.googleapis.com/css2?family=${family.replaceAll(' ', '+')}:wght@400;700&display=swap`;

export const fontLinkHref = (font: FontLink): string | null => {
  if (font.source === 'system') {
    return null;
  }

  if (font.source === 'custom' && font.url) {
    return font.url;
  }

  return googleHref(font.family);
};

type BrandFontLike = { fontFamily?: string | null; fontUrl?: string | null };
type BrandLike = { settings?: { text?: { heading?: BrandFontLike; body?: BrandFontLike } } } | null | undefined;

export const brandFontLinks = (brands: BrandLike[]): FontLink[] =>
  brands.flatMap((brand) => [brand?.settings?.text?.heading, brand?.settings?.text?.body])
    .filter((font): font is BrandFontLike => Boolean(font?.fontFamily))
    .map((font) => ({
      family: font.fontFamily as string,
      url: font.fontUrl ?? null,
      source: font.fontUrl ? 'custom' : 'google',
    }));
